/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Foot_TermsInputs */

const en_mk_foot_terms = /** @type {(inputs: Mk_Foot_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terms of service`)
};

const id_mk_foot_terms = /** @type {(inputs: Mk_Foot_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ketentuan layanan`)
};

/**
* | output |
* | --- |
* | "Terms of service" |
*
* @param {Mk_Foot_TermsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_foot_terms = /** @type {((inputs?: Mk_Foot_TermsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Foot_TermsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_foot_terms(inputs)
	return en_mk_foot_terms(inputs)
});